// import { IResourceComponentsProps } from "@refinedev/core";
// import { MuiCreateInferencer } from "@refinedev/inferencer/mui";

// export const ActionCreate: React.FC<IResourceComponentsProps & { onClose: () => void }> = ({ onClose }) => {
//  return (
//   <MuiCreateInferencer
//    fieldTransformer={(field: any) => {
//     if (["locale", "updatedAt", "publishedAt"].includes(field.key)) {
//      return false;
//     }

//     return field;
//    }}
//   />
//  );
// };

import {
  Autocomplete,
  Box,
  Chip,
  FormControl,
  FormLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Stack,
  TextField,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { useGetIdentity, useTranslation } from "@refinedev/core";
import { Create } from "@refinedev/mui";
import { useForm } from "@refinedev/react-hook-form";
import { FC } from "react";
import { Controller } from "react-hook-form";
import { useQuery } from "react-query";
import { getClients } from "services/client";
import { getContainers } from "services/container";
import { getFarmers } from "services/farmer";
import { getProductlists } from "services/produit";

export enum ActionType {
  IN = "in",
  OUT = "out",
}

export enum CustomerType {
  CLIENT = "CLIENT",
  FARMER = "FARMER",
}

export const ActionCreate: FC<{ onClose?: () => void }> = ({ onClose }) => {
  const { translate } = useTranslation();

  const {
    saveButtonProps,
    refineCore: { formLoading },
    register,
    control,
    formState: { errors },
    watch,
    setValue,
  } = useForm();

  const { data: dataClients } = useQuery({
    queryKey: "clients",
    queryFn: getClients(),
  });

  const { data: dataFarmers } = useQuery({
    queryKey: "farmers",
    queryFn: getFarmers(),
  });

  const { data: dataContainers } = useQuery({
    queryKey: "containers",
    queryFn: getContainers(),
  });

  const { data: dataProductsLists } = useQuery({
    queryKey: "products",
    queryFn: getProductlists(),
  });

  const { data: user } = useGetIdentity<{
    name: string;
    avatar: any;
    id: any;
  }>();
  const userId = user && user.id;

  const data = watch();
  const product_lists = (watch("product_lists") as Array<number>) ?? [];

  return (
    <Create
      isLoading={formLoading}
      saveButtonProps={{
        onClick: (e) => {
          console.log("here", { fv: watch() });
          saveButtonProps.onClick(e);
        },
        disabled: saveButtonProps.disabled,
      }}
    >
      <Box
        component="form"
        sx={{ display: "flex", flexDirection: "column" }}
        autoComplete="off"
      >
        <FormControl sx={{ mt: -1, display: "none" }}>
          <TextField
            type="hidden"
            {...register("user", {
              required: translate("this-field-is-required"),
            })}
            error={!!(errors as any)?.user}
            helperText={(errors as any)?.user?.message}
            margin="normal"
            value={userId}
            InputLabelProps={{ shrink: true }}
            name="user"
          />
        </FormControl>
        <Controller
          control={control}
          name="type"
          rules={{ required: translate("this-field-is-required") }}
          // eslint-disable-next-line
          defaultValue={null as any}
          render={({ field }) => (
            <RadioGroup
              {...field}
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                columnGap: 4,
              }}
            >
              <FormControl>
                <FormLabel>
                  IN
                  <Radio value={ActionType.IN} />
                </FormLabel>
              </FormControl>
              <FormControl>
                <FormLabel>
                  OUT
                  <Radio value={ActionType.OUT} />
                </FormLabel>
              </FormControl>
            </RadioGroup>
          )}
        />

        <Controller
          control={control}
          name="customer_type"
          rules={{ required: translate("this-field-is-required") }}
          // eslint-disable-next-line
          defaultValue={null as any}
          render={({ field }) => (
            <FormControl>
              <FormLabel>{translate("customer-type")}</FormLabel>
              <Select
                {...field}
                variant="outlined"
                label="Container Type"
                sx={{ mt: 1 }}
              >
                {Object.keys(CustomerType).map((item, index) => {
                  return (
                    <MenuItem value={item} key={index}>
                      {item}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          )}
        />

        <TextField
          {...register("quantity", {
            required: translate("this-field-is-required"),
            valueAsNumber: true,
          })}
          error={!!(errors as any)?.quantity}
          helperText={(errors as any)?.quantity?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="number"
          label="Quantity"
          name="quantity"
        />
        {/*
                    DatePicker component is not included in "@refinedev/mui" package.
                    To use a <DatePicker> component, you can follow the official documentation for Material UI.

                    Docs: https://mui.com/x/react-date-pickers/date-picker/#basic-usage
                */}
        <Controller
          control={control}
          name="container"
          rules={{ required: translate("this-field-is-required") }}
          // eslint-disable-next-line
          defaultValue={null as any}
          render={({ field }) => (
            <FormControl sx={{ mb: 1 }}>
              <FormLabel>Container</FormLabel>
              <Select {...field} name="container" label="Container">
                <MenuItem>Select Container</MenuItem>
                {(dataContainers || []).map((item: any, index: number) => (
                  <MenuItem key={index} value={item.id}>
                    {item?.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
        />
        <Autocomplete
          disablePortal
          id="combo-box-demo"
          options={(dataProductsLists || []).filter(
            (item: any) => !product_lists?.includes(item?.id) || []
          )}
          getOptionLabel={(option: any) => {
            return `[${option?.attributes?.code}] + ${option?.attributes?.name}`;
          }}
          onChange={(e, value) => {
            value?.id &&
              setValue("product_lists", [...product_lists, Number(value?.id)]);
          }}
          fullWidth
          // inputValue=""
          sx={{ my: 2 }}
          renderInput={(params) => <TextField {...params} label="Products" />}
        />
        <Stack direction="row" alignItems="center" flexWrap="wrap">
          {(product_lists || []).map((item: any, index: number) => {
            const product_name = (dataProductsLists || []).find(
              (product: any) => Number(product?.id) === Number(item)
            )?.attributes?.name;
            return (
              <Chip
                variant="filled"
                color="primary"
                label={product_name}
                key={index}
                onDelete={(e) =>
                  setValue(
                    "product_lists",
                    (product_lists || []).filter(
                      (product: any) => product !== item
                    )
                  )
                }
                sx={{ m: 1 }}
              />
            );
          })}
        </Stack>

        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <Box mb={2} mt={5}>
            <Controller
              control={control}
              name="date"
              rules={{ required: translate("this-field-is-required") }}
              // eslint-disable-next-line
              defaultValue={null as any}
              render={({ field }) => (
                <DatePicker
                  label="Day"
                  {...field}
                  defaultValue={new Date()}
                  onChange={(newValue: any) => {
                    newValue?.setHours(5, 0, 0, 0);
                    field.onChange(newValue);
                  }}
                />
              )}
            />
          </Box>
        </LocalizationProvider>
        {data?.customer_type === CustomerType.CLIENT ? (
          <Controller
            control={control}
            name="client"
            rules={{ required: translate("this-field-is-required") }}
            // eslint-disable-next-line
            defaultValue={null as any}
            render={({ field }) => (
              <FormControl>
                <FormLabel>Client</FormLabel>
                <Select {...field} name="client" label="Client">
                  <MenuItem>Select Client</MenuItem>
                  {(dataClients || []).map((item: any, index: number) => (
                    <MenuItem key={index} value={item.id}>
                      {item?.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
          />
        ) : data?.customer_type === CustomerType.FARMER ? (
          <Controller
            control={control}
            name="farmer"
            rules={{ required: translate("this-field-is-required") }}
            // eslint-disable-next-line
            defaultValue={null as any}
            render={({ field }) => (
              <FormControl>
                <FormLabel>Farmer</FormLabel>
                <Select {...field} name="farmer" label="Farmer">
                  <MenuItem>Select Farmer</MenuItem>
                  {(dataFarmers || []).map((item: any, index: number) => (
                    <MenuItem key={index} value={item.id}>
                      {item?.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
          />
        ) : null}
      </Box>
    </Create>
  );
};
